$(document).ready(function(){
	$('.search_bar').append("<button id='getOnMap' class='btn' onclick='window.location.href=\"/products/join-our-network-get-on-the-map\"' type='button'>GET ON THE MAP</button>");
});

function show_addresses() {
    var html = "";
    var directions = "";
    for (i = 0; i < addresses.length; i++) {
        var website = "";
        var pin_colour = "";
        if (find_directions) {
            directions = "<div class='directions'><a href='#' onclick='calcRoute(" + addresses[i].id + ");return false;'>" + getDirections + "</a></div>";
        }
        website = "<div class='store_website'><a href='" + addresses[i].website + "' target='_blank'>" + addresses[i].website + "</a></div>";
        if (addresses[i].marker_colour != "main") {
            pin_colour = " style='background-image:url(\"/apps/store-locator/markers/" + addresses[i].marker_colour + "2.png\")' ";
        }
        html = html + "<li " + pin_colour + " onmouseover='hoverStart(" + addresses[i].id + ")' onmouseout='hoverStop(" + addresses[i].id + ")'><div class='distance'>" + addresses[i].distance + "</div><a href='#' onclick='focus_and_popup(" + addresses[i].id + "); return false;'>" + addresses[i].address + "</a>" + website + directions + "</li>";
    }
    if (addresses.length == 0) {
        html = "<li><div class='no_stores_found'>" + noStoresFound + "</div></li>";
    }
    jQuery(".addresses ul").html(html);
    jQuery(".addresses ul").slideDown();
    fixURLS();
        $('.addresses li').each(function(index){
      var id = $(this).find('a').attr('onclick').replace('focus_and_popup(','').replace('); return false;','');
      jQuery.getJSON('/apps/store-locator/get_store_info.php?shop=scenariohome.myshopify.com&data=detailed&store_id=' + id, function(data) {
          var newer_html = $('<div></div>').append(data.data);
          var image_url = $(newer_html).find("div.custom_fields span.custom_field_value").text();
      console.log(image_url);
           if(image_url){
                      $('.addresses li').eq(index).append('<br><div id="MapThumb"><a href='+image_url+' class="mapPopupImage" data-index ><img class="popUpImage" src='+image_url+' alt="Location image" itemprop="image"></a></div>')

                      $('.mapPopupImage').fancybox({
                       'type':'image',
                       'autoDimensions': true,
                       });
                    }
	});
	});
}

$(document).ready(function(){

    $('.addresses li').each(function(index){
      var id = $(this).find('a').attr('onclick').replace('focus_and_popup(','').replace('); return false;','');
      jQuery.getJSON('/apps/store-locator/get_store_info.php?shop=scenariohome.myshopify.com&data=detailed&store_id=' + id, function(data) {
          var newer_html = $('<div></div>').append(data.data);
          var image_url = $(newer_html).find("div.custom_fields span.custom_field_value").text();
      console.log(image_url);
           if(image_url){
                      $('.addresses li').eq(index).append('<br><div id="MapThumb"><a href='+image_url+' class="mapPopupImage" data-index ><img class="popUpImage" src='+image_url+' alt="Location image" itemprop="image"></a></div>')

                      $('.mapPopupImage').fancybox({
                       'type':'image',
                       'autoDimensions': true,
                       });
                    }
	});
	});

});